import { render, staticRenderFns } from "./Shipinzhishi.vue?vue&type=template&id=75306112&scoped=true"
import script from "./Shipinzhishi.vue?vue&type=script&lang=js"
export * from "./Shipinzhishi.vue?vue&type=script&lang=js"
import style0 from "./Shipinzhishi.vue?vue&type=style&index=0&id=75306112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75306112",
  null
  
)

export default component.exports